import { useAppSelector } from '@/redux/hooks';
import { showDemoDataSelectors } from '@/redux/selectors';

import { Stats } from './components/Stats';
import { Latest } from './components/Latest';
import { ThisIsDemoData } from '../../ThisIsDemoData';

const Alerts = () => {
  const isShowDemoData = useAppSelector(showDemoDataSelectors.byCompliance);

  return (
    <>
      {isShowDemoData && <ThisIsDemoData />}
      <Stats />
      <Latest />
    </>
  );
};

export default Alerts;
